import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ff89172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "ABOUT US", -1))
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_5 = { style: {"flex":"8"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"11"} }, null, -1))
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_9 = { style: {"flex":"17"} }
const _hoisted_10 = { class: "line-with-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#8A6B08"} }, "Work Model", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, reactive } from 'vue'
  import type { TabsPaneContext } from 'element-plus'
  import { useRoute, useRouter } from 'vue-router'

  import CardText from '@/components/CardText.vue'
  import Image from '@/components/Image.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  const onBack = () => {
    router.back();
    // notify('Back')
  }

  const img = ref('work-model.png');

  const redirect = ref('/contact');

  const joinUs = reactive([
    {
      title:'Join Us',
      data:'<b style="text-decoration: underline; cursor: pointer;">APPLY NOW and BE OUR GEP Overseas Business PARTNER</b>'
    }
  ]);

  const paragraph = [
    {
      title:'Introduction',
      data:'The GEP Group is an Australian based company whose main objective is to create educational alliances and partnerships with various Colleges outside Australia.<br><br>GEP GROUP has three main core businesses, Education-Training-Employment.'
    },
    {
      title:'Education',
      data:'1. To introduce Australian Vocational Education and Training (VET) curriculum to another college overseas through agreed partnership terms.  The issuance of qualification is based on ASQA (Australian Skills and Quality Authority) standards.<br><br>2. Recruitment of genuine students for Australian RTOs and Universities with completed eligibility and qualifications as required.'
    },
    {
      title:'Traineeship',
      data:'1. GEP assists Sub Class Visa 407 holders in recruiting appropriate candidates ready for Occupational Traineeships.<br><br>2. Can create Training Plans for various individuals or industry.<br><br>3. Recruit 407 Candidates for Approved Sponsors.<br><br>4. Deliver the Outcome Based Assessment (OBA) Review for Internationally Qualified Nurses (IQN).'
    },
    {
      title:'Employment',
      data:'1. Assist Employers experiencing Skills Shortage in Australia to recruited Skill labour overseas under Labour Hire Agreement and Visa 482 or Visa 494 together with our Migration Partners.<br><br>2.	Assist Australian Employers who would like to recruit in the Philippines through POEA Accredited Agents.'
    },
    {
      title:'Gep Group Overseas Business Partners',
      data:'GEP is looking for Business Partners in other countries.<br><br><b>ELIGIBILITY REQUIREMENT FOR GEP OVERSEAS PARTNER</b><br>1.	If with existing business, it must be profitable in the last three years<br>2. If it is a new set-up business, owners must be financially capable.<br>3. With good and ethical standing as a business.<br>4. Must be able to afford an Office with at least one training room (or boardroom).<br>5.	Three Business References Required (partners and supplier).<br><br><b>HOW DOES THE PARTNERSHIP WORK?</b><br>1. Australian Colleges look for Overseas delivery partners and International Students.<br>2. GEP Overseas Partner will find an appropriate College to partner with the Australian RTO and will also recruit for Students who would like to study in Australia.<br><br><b>INCOME STREAMS FOR GEP OVERSEAS PARTNERS</b><br>1.	On Delivery Partnerships<br>2. On Student Recruitment<br>3. Recruitment for Occupational Traineeship (Visa 407)'
    }
  ];

  const data = reactive(
    {
      paragraph:paragraph
    }
  );
    
  

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_page_header, { onBack: onBack })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(CardText, {
          value: data.paragraph
        }, null, 8, ["value"]),
        _createElementVNode("h3", _hoisted_10, [
          _createVNode(_component_el_divider, {
            class: "divider",
            "border-style": "double"
          }),
          _hoisted_11,
          _createVNode(_component_el_divider, {
            class: "divider",
            "border-style": "double"
          })
        ]),
        _createVNode(Image, { value: img.value }, null, 8, ["value"]),
        _createVNode(CardText, {
          value: joinUs,
          click: redirect.value
        }, null, 8, ["value", "click"])
      ]),
      _hoisted_12
    ]),
    _hoisted_13
  ]))
}
}

})